
import { Component, Vue, Watch } from 'vue-property-decorator'
import { GetAdminLogList } from '@/api/admin/payment'
import { GetToken } from '@/libs/util'
import moment from 'moment'
@Component
export default class UserRIskConf extends Vue {
    SysConstType: any = {}
    select = {
        log_type_List: [], //操作分类
        log_type_de_List: [], //操作详细分类
        dataTime1: (this as any).getCurrentZeroDay(),
        dataTime2: ['00:00:00', '23:59:59'],
        dataTime: [(this as any).getCurrentZeroDay(), new Date(new Date().setHours(23, 59, 59, 59))]
    }
    table = {
        params: {
            type: 0,
            desc_type: 0,
            end_time: 0,
            manager_id: null,
            ip: '',
            oper_id: '',
            page: 1,
            limit: 10
        },
        data: [],
        columns: [
            { type: 'index', title: '序号', width: 50, align: 'center' },
            { key: 'func', align: 'center', width: 140, resizable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '所属盘口', '显示对应的所属盘口') },
            { key: 'admin_id', align: 'center', width: 140, resizable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '用户UID', '显示对应的用户UID') },
            {
                key: 'oper_id',
                align: 'center',
                width: 140,
                resizable: true,
                render: (h, params) => {
                    // return h('div',params.row.oper_id+"("+params.row.oper_type+")")
                    //   [
                    //     h("span", params.row.oper_id),
                    //     h("span", { style: "color:#bbb" }, `(${params.row.oper_type})`)
                    //   ]
                    return h('div', '')
                },
                renderHeader: (h, params) => {
                    return (this as any).renderHeader(h, '风控标签', '显示对应的风控标签')
                }
            },
            {
                key: 'type',
                align: 'center',
                width: 140,
                resizable: true,
                render: (h, params) => h('div', this.select.log_type_List[params.row.type - 1] ? this.select.log_type_List[params.row.type - 1]['name'] : ''),
                renderHeader: (h) => (this as any).renderHeader(h, '投注金额', '显示对应的投注金额')
            },
            {
                key: 'agent_fee',
                align: 'center',
                width: 140,
                resizable: true,
                render: (h, params) => {
                    return h(
                        'div',
                        // moment(params.row.create_time * 1000).format("YYYY-MM-DD HH:mm:ss")
                        ''
                    )
                },
                renderHeader: (h, params) => (this as any).renderHeader(h, '返奖金额', '显示对应的返奖金额')
            },
            { key: 'ip', align: 'center', width: 140, resizable: true, filterable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '玩家盈亏', '显示对应的玩家盈亏') },
            { key: 'ip', align: 'center', width: 140, resizable: true, filterable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '转入金额', '显示对应的玩家转入金额') },
            { key: 'ip', align: 'center', width: 140, resizable: true, filterable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '提取金额', '显示对应的玩家提取金额') },
            { key: 'ip', align: 'center', width: 140, resizable: true, filterable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '添加时间', '显示对应的玩家的添加时间') },
            { key: 'ip', align: 'center', width: 140, resizable: true, filterable: true, renderHeader: (h, params) => (this as any).renderHeader(h, '风控备注', '显示对应的玩家的风控备注') },
            {
                key: '',
                align: 'center',
                title: '管理',
                minWidth: 200,
                fixed: (this as any).isMOble() ? '' : 'right',
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: { type: 'primary' },
                                style: { margin: '2px', padding: '5px 20px' },
                                on: {
                                    click: () => {
                                        // this.order(params.row);
                                        // this.Amount_Modal.show = true;
                                    }
                                }
                            },
                            '修改标签'
                        ),
                        h(
                            'Button',
                            {
                                props: { type: 'error' },
                                style: { margin: '2px', padding: '5px 20px' },
                                on: {
                                    click: () => {
                                        // this.order(params.row);
                                        // this.Amount_Modal.show = true;
                                    }
                                }
                            },
                            '删除'
                        )
                    ])
                }
            }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40]
    }
    ChannelMoney_Modal = { show: false, data: {}, type: 0 }
    //获取列表
    getAdminLogList(num?) {
        if (num) this.table.params.page = 1
        let params = {
            ...this.table.params,
            manager_id: Number(this.table.params.manager_id)
        }
        params['start_time'] = (this as any).getSecondResult(moment(this.select.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'))
        params['end_time'] = (this as any).getSecondResult(moment(this.select.dataTime[1]).format('YYYY-MM-DD HH:mm:ss'))
        GetAdminLogList(params).then((res) => {
            this.table.data = res._param.list || []
            this.table.total = res._param.total
        })
    }
    //列表分页
    pagechange(page) {
        this.table.params.page = page
        this.getAdminLogList()
    }
    //列表分条
    limitchange(limit) {
        this.table.params.page = 1
        this.table.params.limit = limit
        this.getAdminLogList()
    }

    getSysConst() {
        let SysConstType = GetToken().SysConstType
        //通道金额类型
        let log_type_arr: any = []
        for (let i in SysConstType.log_type) {
            let obj = {}
            ;(obj['value'] = Number(i)), (obj['name'] = SysConstType.log_type[i])
            log_type_arr.push(obj)
        }
        this.select.log_type_List = log_type_arr

        //支付类型
        let log_type_de_arr: any = []
        for (let i in SysConstType.log_type_de) {
            let obj = {}
            ;(obj['value'] = Number(i)), (obj['name'] = SysConstType.log_type_de[i])
            log_type_de_arr.push(obj)
        }
        this.select.log_type_de_List = log_type_de_arr
    }
    //时间戳转换
    datacha(date) {
        this.select.dataTime = []
        this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[0]))
        this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[1]))
    }
    //时间戳转换
    changeTime(time) {
        this.select.dataTime2 = time
        let date = moment(this.select.dataTime1).format('YYYY-MM-DD')
        this.select.dataTime = []
        this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[0]))
        this.select.dataTime.push(new Date(date + ' ' + this.select.dataTime2[1]))
    }
    created() {
        // let list: any = [{}];
        // this.table.data = list;
        // this.getAdminLogList()
        // this.getSysConst()
    }
}
